module.exports = __webpack_public_path__ + "media/03 anticipation.b25f7b80.mp3";